import { queryOptions } from '@tanstack/react-query';
import { getBodyVehicleCorrectiveImageTabsFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyVehicleCorrectiveImageTabs/getBodyVehicleCorrectiveImageTabsFunction';
export const getBodyVehicleCorrectiveImageTabsOpions = (id: number) =>
  queryOptions({
    queryKey: ['getBodyVehicleCorrectiveImageTabsOpions', id],
    queryFn: () =>
      getBodyVehicleCorrectiveImageTabsFunction({
        id: id,
      }),
  });
